"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_START_ANIMATION = exports.CLASS_ALLOW_ANIMATION = exports.CLASS_SOLR_SUGGESTION_LINK = exports.CLASS_END = exports.CLASS_FILLED = exports.CLASS_OPACITY_0 = exports.CLASS_ROTATING = exports.CLASS_INVALID = exports.CLASS_NAVBAR_OPEN = exports.CLASS_COLLAPSED = exports.CLASS_SHOW = exports.CLASS_ACTIVE = exports.CLASS_SHOW_NAV_BG_LAYER = exports.CLASS_HIDE_NAV = exports.CLASS_D_NONE = exports.CLASS_FIXED = exports.CLASS_STICKY = exports.CLASS_OPEN = void 0;
exports.CLASS_OPEN = 'is-open';
exports.CLASS_STICKY = 'is-sticky';
exports.CLASS_FIXED = 'is-fixed';
exports.CLASS_D_NONE = 'd-none';
exports.CLASS_HIDE_NAV = 'hide-nav';
exports.CLASS_SHOW_NAV_BG_LAYER = 'show-nav-bg-layer';
exports.CLASS_ACTIVE = 'is-active';
exports.CLASS_SHOW = 'show';
exports.CLASS_COLLAPSED = 'collapsed';
exports.CLASS_NAVBAR_OPEN = 'navbar-open';
exports.CLASS_INVALID = 'is-invalid';
exports.CLASS_ROTATING = 'is-rotating';
exports.CLASS_OPACITY_0 = 'opacity-0';
exports.CLASS_FILLED = 'is-filled';
exports.CLASS_END = 'is-end';
exports.CLASS_SOLR_SUGGESTION_LINK = 'tx-solr-suggestion-link';
exports.CLASS_ALLOW_ANIMATION = 'allow-animation';
exports.CLASS_START_ANIMATION = 'start-animation';
